/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1235
 */

var r = require(/* 1075 */"../../1581/1075")
module.exports = r && !Symbol.sham && "symbol" == typeof Symbol.iterator
